import { lazy } from "react";

const WebHome = lazy(()=>import("../pages"));
const Home = lazy(()=>import("../pages/Home"));
const Login = lazy(()=>import("../pages/Auth/Login"));
const AllAssets = lazy(()=>import("../pages/Assets"));
const Signup = lazy(()=>import("../pages/Auth/Signup"));
const MyAssets = lazy(()=>import("../pages/Assets/MyAssets"));
const PageNotFound = lazy(()=>import("../pages/PageNotFound"));
const Faq = lazy(()=>import("../pages/Content Management/Faq"));
const SavedAsset = lazy(()=>import("../pages/Assets/SavedAsset"));
const HelpSupport = lazy(()=>import("../pages/Auth/HelpSupport"));
const AssetDetail = lazy(()=>import("../pages/Assets/AssetDetail"));
const OwnerDetail = lazy(()=>import("../pages/Assets/OwnerDetail"));
const AccountSetting = lazy(()=>import("../pages/Account Setting"));
const GetSecurPoint = lazy(()=>import("../pages/Auth/GetSecurPoint"));
const ResetPassword = lazy(()=>import("../pages/Auth/ResetPassword"));
const BrowseCategory = lazy(()=>import("../pages/Home/BrowseCategory"));
const ForgotPassword = lazy(()=>import("../pages/Auth/ForgotPassword"));
const OtpVarification = lazy(()=>import("../pages/Auth/OtpVarification"));
const PrivacyPolicy = lazy(()=>import("../pages/Content Management/PrivacyPolicy"));
const TermsofService = lazy(()=>import("../pages/Content Management/TermsofService"));

export const webPaths = {
  WebHome: "/",
  Home: "/home",
  MyAssets: "/my-assets",
  AllAssets: "/all-assets",
  SavedAsset: "/saved-assets",
  AssetDetail: "/assets-detail/:id",
  PageNotFound: "/*",
  Login: "/log-in",
  Signup: "/sign-up",
  ResetPassword: "/reset-password",
  AccountSetting: "/account-setting/:type",
  ForgotPassword: "/forgot-password",
  OtpVarification: "/otp-verification",
  PrivacyPolicy: "/privacy-policy",
  TermsofService: "/terms-of-service",
  BrowseCategory: "/browse-category",
  GetSecurPoint: "/get-securpoint",
  HelpSupport: "/help-and-support",
  Faq: "/faq",
  OwnerDetail: "/user-detail/:id",
};

const webRoutes = [
  {
    label: "WebHome",
    path: webPaths?.WebHome,
    element: <WebHome />,
    isPrivate: false,
  },
  {
    label: "Login",
    path: webPaths?.Login,
    element: <Login />,
    isPrivate: false,
  },
  {
    label: "Signup",
    path: webPaths?.Signup,
    element: <Signup />,
    isPrivate: false,
  },
  {
    label: "ForgotPassword",
    path: webPaths?.ForgotPassword,
    element: <ForgotPassword />,
    isPrivate: false,
  },
  {
    label: "OtpVarification",
    path: webPaths?.OtpVarification,
    element: <OtpVarification />,
    isPrivate: false,
  },
  {
    label: "ResetPassword",
    path: webPaths?.ResetPassword,
    element: <ResetPassword />,
    isPrivate: false,
  },
  {
    label: "Home",
    path: webPaths?.Home,
    element: <Home />,
    isPrivate: true,
  },
  {
    label: "MyAssets",
    path: webPaths?.MyAssets,
    element: <MyAssets />,
    isPrivate: true,
  },
  {
    label: "AllAssets",
    path: webPaths?.AllAssets,
    element: <AllAssets />,
    isPrivate: false,
  },
  {
    label: "SavedAsset",
    path: webPaths?.SavedAsset,
    element: <SavedAsset />,
    isPrivate: true,
  },
  {
    label: "AssetDetail",
    path: webPaths?.AssetDetail,
    element: <AssetDetail />,
    isPrivate: false,
  },
  {
    label: "AccountSetting",
    path: webPaths?.AccountSetting,
    element: <AccountSetting />,
    isPrivate: true,
  },
  {
    label: "Faq",
    path: webPaths?.Faq,
    element: <Faq />,
    isPrivate: false,
  },
  {
    label: "PrivacyPolicy",
    path: webPaths?.PrivacyPolicy,
    element: <PrivacyPolicy />,
    isPrivate: false,
  },
  {
    label: "TermsofService",
    path: webPaths?.TermsofService,
    element: <TermsofService />,
    isPrivate: false,
  },
  {
    label: "BrowseCategory",
    path: webPaths?.BrowseCategory,
    element: <BrowseCategory />,
    isPrivate: true,
  },
  {
    label: "GetSecurPoint",
    path: webPaths?.GetSecurPoint,
    element: <GetSecurPoint />,
    isPrivate: true,
  },
  {
    label: "HelpSupport",
    path: webPaths?.HelpSupport,
    element: <HelpSupport />,
    isPrivate: false,
  },
  {
    label: "PageNotFound",
    path: webPaths?.PageNotFound,
    element: <PageNotFound />,
    isPrivate: false,
  },
  {
    label: "OwnerDetail",
    path: webPaths?.OwnerDetail,
    element: <OwnerDetail />,
    isPrivate: false,
  },
];

export default webRoutes;
